/*
 * @Author: dali
 * @Date: 2022-09-28 11:08:22
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2024-03-05 16:46:44
 * @FilePath: \gerlun-react-website\src\pages\case\index.jsx
 * @Description:
 */
import React, { useState, useEffect } from 'react'
import styles from './case.scss'
import case_1 from '../../common/images/case/case-1.jpg'
import User from '@/modules/user'
import { Pagination } from 'antd'
import { useNavigate } from 'react-router-dom'
import { isMobileAgent } from '@/utils/utils'
import CaseSkeleton from './CaseSkeleton'

const Case = (props) => {
  const navigate = useNavigate()
  const user = new User()
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const [current, setCurrent] = useState(1)
  const form = {
    pageSize: 6,
    pageNum: 1,
    articleName: '',
    releaseColumn: '成功案例',
    releaseColumnId: ''
  }
  const componentDidMount = (form)=>{
    setData([])
    if (isMobileAgent()) {
      form.releaseColumn = '手机案例'
    }
    user.getArticleList(form)
      .then(res => {
        setData(res.result)
        setTotal(res.total)
        const portalEle = document.getElementById('caseUl')
        if (portalEle.children.length === 2 || portalEle.children.length === 1) {
          portalEle.style.justifyContent = 'center'
        } else {
          portalEle.style.justifyContent = 'space-between'
        }
      })
      .catch((res) => {
        setData([])
        console.log(res)
      })
  }
  const getPage = (page) => {
    setCurrent(page)
    form.pageNum = page
    componentDidMount(form)
  }
  useEffect(()=>{
    componentDidMount(form)
  }, [isMobileAgent()])
  const handleNavigate = (path) => {
    window.scrollTo({
      top: 0
    })
    navigate(path)
  }
  return <section className={styles['case']}>
    <div className={styles['case-contnet']}>
      <h2>成功案例</h2>
      <ul id='caseUl' className={styles['case-ul']}>
        { data && data.length > 0 ? data.map(item => {
          return <li key={item.id}>
            <a href='/#' onClick={(e) => handleNavigate(`/case-dtl/${item.id}`) || e.preventDefault()}>
              <div className={styles['case-content']}><img src={item.thumbnails === null || item.thumbnails.length === 0 ? case_1 : item.thumbnails[0].url} alt='case_1' /></div>
              {/* <h4>{item.articleName}</h4> */}
              <div className={styles['digest-content']} dangerouslySetInnerHTML = {{ __html: item.digest }}></div>
            </a>
          </li>
        }) : <CaseSkeleton /> }
      </ul>
      <Pagination showSizeChanger={false} pageSize={ form.pageSize } total={ total } style={{ textAlign: 'center' }} current={current} onChange={getPage} />
    </div>
  </section>
}

export default Case
